import Layout from "components/Layout";
import React from "react";
import ReceiveSettingEditForm from "./components/ReceiveSettingEditForm";

function ReceiveSettingEditPage() {
  return (
    <Layout title="SMS 수신설정 수정/삭제">
      <ReceiveSettingEditForm />
    </Layout>
  );
}

export default ReceiveSettingEditPage;
